module.exports = __webpack_public_path__ + "img/login-banner.97afaf37.png";